/**
 * What the assistant says before a question is asked (AB#27211).
 *
 * Mirrors DEFAULT_GREETING / DEFAULT_COMPOSER_PLACEHOLDER in the React HelpAssistant, verbatim.
 * One wording across every surface is the point: a user who opens the assistant in the admin
 * portal and again in a React portal must be met by the same thing twice. Change one, change both.
 */
export const HELP_ASSISTANT_GREETING =
	'Welcome to Syrenis Help Assistant. How can I help you today?'

export const HELP_ASSISTANT_COMPOSER_PLACEHOLDER = 'Ask anything about Syrenis…'
